import { Box, Divider, Grid } from "@mui/material";
import { librarySelectedTab } from "components/app/App.slice";
import Button from "components/common/Button";
import NoPlansBanner from "components/common/NoPlansBanner";
import Typography from "components/common/Typography";
import ActionBar from "components/features/dashboard/ActionBar";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { triggerOnboadingWizard } from "utils/CommonFunctions";
import { routes } from "utils/routes";
import { pageNames } from "utils/Types";

import MetricDetails from "./MetricDetails";

function SuggestedPlans() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isAdmin, isAbovePropertyUser } = useAppSelector((state: any) => state.app);
  const dashboardMetrics = useAppSelector((state) => state.Dashboard.dashboardMetrics);
  const plansList: any = useAppSelector((state) => state.suggestedPlans.SuggestedPlansList);

  const redirectToSuggestedPlans = () => {
    navigate(routes.Library);
    dispatch(librarySelectedTab(3));
  };

  return (
    <Grid
      item
      // display="flex"
      // flexDirection="column"
      xs={12}
      md={3.5}
      sx={{ backgroundColor: tokens.Background.General.Primary }}
    >
      {dashboardMetrics && Object.keys(dashboardMetrics)?.length > 0 && (
        <>
          <Grid item xs={12} gap="8px" sx={{ padding: "24px", maxHeight: "300px", overflow: "hidden" }}>
            {Object.keys(dashboardMetrics)
              .splice(0, 3)
              ?.map((metric: any) => {
                return <MetricDetails key={metric} metric={dashboardMetrics[metric]} />;
              })}
          </Grid>
          <Divider
            sx={{
              width: "100%",
              backgroundColor: tokens.Border.General.Secondary,
              marginBottom: "8px"
            }}
          ></Divider>
        </>
      )}{" "}
      {plansList?.length > 0 && !isAdmin && !isAbovePropertyUser && (
        <Grid xs={12} padding="24px">
          <Button width={"100%"} label="See all suggestions" size="Small" onClick={redirectToSuggestedPlans} />
        </Grid>
      )}
      <Grid
        id="actionItemsDiv"
        item
        xs={12}
        padding="24px"
        sx={{
          maxHeight: "128vh",
          overflowY: "auto"
        }}
      >
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              mb: "24px"
            }}
          >
            <Typography showBold color={tokens.Text.General.Secondary}>
              Suggested Plans
            </Typography>
          </Box>
          {plansList?.length > 0 ? (
            plansList.map((element: any, index: any) => {
              return (
                <ActionBar
                  key={element?.id}
                  element={element}
                  url={`/plandetails/${element.id}`}
                  suggested={true}
                  shouldNavigate={!isAdmin && !isAbovePropertyUser}
                />
              );
            })
          ) : (
            <NoPlansBanner
              isDashboard
              pageName={pageNames.suggested}
              onClickHandle={() => triggerOnboadingWizard(dispatch)}
            />
          )}
        </>
      </Grid>
    </Grid>
  );
}

export default SuggestedPlans;
